import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";
import { getAxiosCancelToken } from "../../../utils/getAxiosCancelToken";
import apiRequestType from "../../apiRequestType";

let cancelToken;
const getUserGroup = (pageNum, pageSize, searchKey) => {
  cancelToken = getAxiosCancelToken(cancelToken);
  return apiRequestType(
    apiTypes.GET,
    apiConstants.ADMIN.GROUP_MANAGEMENT.GET_USER_GROUPS(
      pageNum,
      pageSize,
      searchKey
    ),
    "",
    cancelToken
  );
};

export default getUserGroup;
